import { render, staticRenderFns } from "./IntegrationInformationView.vue?vue&type=template&id=0b833b5e&"
import script from "./IntegrationInformationView.vue?vue&type=script&lang=js&"
export * from "./IntegrationInformationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports